// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ad9b6aa0","404":"3c06d607","787":"bb683ef8"}[chunkId] + ".chunk.js";
};